export default "__VITE_ASSET__nRDcg3yR__"